import { render, staticRenderFns } from "./SalesInfoBox.vue?vue&type=template&id=68729715&"
import script from "./SalesInfoBox.vue?vue&type=script&lang=js&"
export * from "./SalesInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./SalesInfoBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports